export const SET_LOGIN = "SET_LOGIN";
export const SET_LOGIN_TOGGLE = "SET_LOGIN_TOGGLE";
export const BASE_URL = "BASE_URL";
export const SET_RESPONSE = "SET_RESPONSE";
export const SET_SHIFT = "SET_SHIFT";
